import { ToggleButton, Typography } from "@mui/material";

import { ToggleButtonGroup } from "@mui/material";
import { TeamPositionPlayers, TeamPositionPlayer } from "./TeamSubmission";

function ToggleVisitingPlayer({
  positionPlayer,
  index,
  positionIndex,
  teamMembers,
  setTeamMembers,
}: {
  positionPlayer: TeamPositionPlayer;
  index: number;
  positionIndex: number;
  teamMembers: TeamPositionPlayers[];
  setTeamMembers: (teamMembers: TeamPositionPlayers[]) => void;
}) {
  return (
    <ToggleButtonGroup
      value={
        positionPlayer.isVisitingPlayer ? "visiting-player" : "club-player"
      }
      exclusive
      color="primary"
      onChange={(event, newValue) => {
        if (newValue !== null) {
            const newTeamMembers = [...teamMembers];
            const isVisitingPlayer = newValue === "visiting-player";
              newTeamMembers[index].players[positionIndex].isVisitingPlayer = isVisitingPlayer;
              if (!isVisitingPlayer) {
                newTeamMembers[index].players[positionIndex].visitingPlayerName = undefined;
                newTeamMembers[index].players[positionIndex].visitingPlayerRating = undefined;
              } else {
                newTeamMembers[index].players[positionIndex].playerId = null;
              }
            setTeamMembers(newTeamMembers);
        }
      }}
      aria-label="Player Type"
    >
      <ToggleButton value="club-player" aria-label="club player">
        <Typography>Club Player</Typography>
      </ToggleButton>
      <ToggleButton value="visiting-player" aria-label="visiting player">
        <Typography>Visiting Player</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default ToggleVisitingPlayer;
